import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsCU: CultureInfo = {
  name: 'es-CU',
  displayName: 'Spanish (Cuba)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-CU',
  parent: CultureInfoEs
};
